import axios from '../utils/request'

//  登录
export const loginApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/login`,
        data
    })
}

// 注册
export const registerApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/regisr`,
        data
    })
}
// 忘记密码
export const repasswordApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/repassword`,
        data
    })
}
// 重置密码-设置密码
export const repasswordSetApi = (query, data) => {
    return axios({
        method: 'post',
        url: `/yin/modify/repassword`,
        data
    })
}
// OSS上传临时授权
export const getOssAuth = (data) => {
    return axios({
        method: 'post',
        url: '/yin/common/upload',
        data
    })
}

//   首页
export const getHomeInfoApi = () => {
    return axios({
        method: 'get',
        url: `/yin/index`
    })
}

// 下单必读/联系方式
export const getSettingApi = () => {
    return axios({
        method: 'get',
        url: `/yin/setting`
    })
}

// 操作指引
export const getInstructionApi = () => {
    return axios({
        method: 'get',
        url: `/yin/instruction`
    })
}


// 管理中心
export const manegeCenterApi = () => {
    return axios({
        method: 'get',
        url: `/yin/paper/order/static`
    })
}

// 订单列表
export const orderManegeApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/paper/order/list`,
        params
    })
}

// 订单详情
export const orderDetailApi = (query, params) => {
    return axios({
        method: 'get',
        url: `/yin/paper/order/${query.orderId}`,
        params
    })
}
// 订单导出
export const orderListImportApi = (params) => {
    return axios({
        method: 'get',
        url: '/yin/paper/order/export',
        params,
        responseType: "arraybuffer"
    })
}
// 订单支付
export const orderPayApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/pay/${data.orderId}`
    })
}
// 订单支付 定时判断订单是否支付完成
export const orderPayCheckApi = (orderNo) => {
    return axios({
        method: 'get',
        url: `/yin/paper/order/wechat/pay/status/${orderNo}`
    })
}
// 取消订单
export const cancelOrderApi = (query) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/cancel/${query.orderId}`
    })
}
// 补传证书
export const authenticationApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/authentication`,
        data
    })
}
// 订单-修改地址
export const changeAddressApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/address`,
        data
    })
}
// 订单-修改地址-预估快递费
export const changeAddressPostageApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/address/postage`,
        data
    })
}

// 订单-申请售后
export const orderRefundApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/refund`,
        data
    })
}


// 财务明细列表
export const financeListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/finance/record`,
        params
    })
}

// 财务明细列表导出
export const financeListImportApi = (params) => {
    return axios({
        method: 'get',
        url: '/yin/finance/record/export',
        params,
        responseType: "arraybuffer"
    })
}
// 会员信息
export const personalInfoApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/user/info`,
        params
    })
}
// 会员信息 -认证
export const personalInfoUnloadApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/user/certification`,
        data
    })
}

// 授权书
export const authenticationListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/authentication/list`,
        params
    })
}
// 授权书-作废
export const authenticationCancelApi = (data) => {
    return axios({
        method: 'put',
        url: `/yin/authentication/cancel/${data.authenticationId}`,
        data
    })
}
// 授权书-修改名称
export const authenticationChangeNameApi = (data) => {
    return axios({
        method: 'put',
        url: `/yin/authentication/title/${data.authenticationId}`,
        data
    })
}
// 授权书-新增
export const authenticationAddApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/authentication/${data.authenticationId}`,
        data
    })
}
// 发票抬头
export const invoiceTitleApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/invoice/title/list`,
        params
    })
}
// 发票抬头 编辑
export const invoiceTitleEditApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/invoice/title/${data.invoiceTitleId}`,
        data
    })
}
// 修改密码
export const changePasswordApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/user/modify/password`,
        data
    })
}
// 线上支付
export const onlinePayApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/user/pay`,
        data
    })
}
// 线上支付 -定时查询是否支付完成
export const onlinePayCheckApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/user/pay/${data.orderNo}`
    })
}
// 售后记录
export const refundListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/refund/list`,
        params
    })
}

// 售后记录-详情
export const refundDetailApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/refund/${params.refundId}`,
        params
    })
}
// 快递公司
export const expressListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/express/list`,
        params
    })
}
// 路线
export const routeListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/route/list`,
        params
    })
}


// 不干胶类型
export const categoryListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/paper/category/list`,
        params
    })
}

// 不干胶类型详情
export const categoryDetailApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/paper/category/${params.paperCategoryId}`,
        params
    })
}

// 不干胶商品描述
export const categoryProductDetailApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/product/detail`,
        params
    })
}

// 不干胶类型-报价
export const orderPriceApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/price`,
        data
    })
}
// 下单
export const sureOrderApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/add`,
        data
    })
}
// 批量下单
export const batchOrderApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/batchOrder`,
        data
    })
}
// 生成微信支付二维码
export const wechatQrCodeApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/paper/order/wechat/pay/qrcode`,
        data
    })
}

// 微信退款
export const wechatRefundApi = (orderId) => {
    return axios({
        method: 'post',
        url: `/yin/manager/order/${orderId}/wechat/refund`
    })
}

// 领券中心
export const couponListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/coupon`,
        params
    })
}

// 领取优惠券
export const getCouponApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/user/coupon`,
        data
    })
}

// 我的优惠券
export const myCouponListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/user/coupon`,
        params
    })
}

// 物流信息
export const logisticsListApi = (params) => {
    return axios({
        method: 'get',
        url: `/yin/paper/order/track/${params.orderId}`,
        params
    })
}

// 查询专属客服信息
export const getCustomerServiceApi = (data) => {
    return axios({
        method: 'get',
        url: `/yin/order/salespeople/user/${data}`,
    })
}

// 支付接口
export const goPayApi = (data) => {
    return axios({
        method: 'post',
        url: `/yin/pay/goPay`,
        data
    })
}



